import React from 'react';
import { makeStyles } from '@mui/styles';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import {
  ROUTE_STATUS_WARNING,
  NO,
  YES,
  ROUTE_STATUS_WARNING_MESSAGE,
} from '../../../constants/strings';
import { Text } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';

const useStyles = makeStyles(() => warningTextModal);

const RevertRouteWarning = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={ROUTE_STATUS_WARNING.toUpperCase()}
      actions={
        <>
          <Button
            minWidthZero
            onClick={onClose}
            className={classes.yellowButton}
          >
            {NO}
          </Button>
          <Button
            minWidthZero
            onClick={onConfirm}
            className={classes.blueButton}
          >
            {YES}
          </Button>
        </>
      }
    >
      <Text className={classes.text}>{ROUTE_STATUS_WARNING_MESSAGE}</Text>
    </SimpleModal>
  );
};

export default RevertRouteWarning;
